import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=41981ac8&scoped=true"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=41981ac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41981ac8",
  null
  
)

export default component.exports